import { Navigate, Outlet } from "react-router-dom";
import { Loading } from "@/components/atoms";
import { AccountType } from "@/constants/accountTypes";
import { useAppSelector } from "@/redux/hooks";
import { profileSelector } from "@/redux/slices/profile/selectors";

const CLIENT_TYPES: string[] = [AccountType.PASSENGER, AccountType.EXECUTIVE_ASSISTANT, AccountType.TRAVEL_MANAGER];

/**
 * Route guard for the client portal.
 * Ensures the authenticated user is a client type and has completed registration.
 * Parent route must be wrapped with RequireAuth.
 */
export const RequireClientAccount = () => {
  const profile = useAppSelector(profileSelector);

  // Profile not loaded yet — show loading (ClientAccountProvider will fetch it)
  if (!profile) return <Loading />;

  const accountType = profile.accountMetadata?.type;
  const isRegisterComplete = profile.accountMetadata?.isRegisterComplete ?? false;

  // Not a client type — redirect to operator dashboard
  if (!accountType || !CLIENT_TYPES.includes(accountType)) {
    return <Navigate to="/" replace />;
  }

  // Registration incomplete — redirect to client onboarding
  if (!isRegisterComplete) {
    return <Navigate to="/onboarding/client" replace />;
  }

  return <Outlet />;
};
